import { EMAIL_REGEX } from "shared/utils/validate"

//todo Неочевидное поведение. Должно возвращать true, если проходит валидацию.
export const validateEmail = (n:string, msg?: any) => {
    if (!n.match(EMAIL_REGEX[0])) {
        msg && msg()
        return true;
    }
    return false
}

export const validatePhone= (n:string, msg?: any) => {
    if (!n.match(/[7-8\+]{1,2}\s[0-9]{3}\s[0-9]{3}-[0-9]{2}-[0-9]/)) {
        msg && msg()
        return true;
    }

    return false
}

export const validateLink = (n: string, msg?: any) => {
    if (!n.match(/^(ftp|http|https):\/\/[^ "]+$/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateWord= (n: string, msg?: any) => {
    if (n.match(/[0-9~!@#$%^&*()_+=-`{}\.\,]/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateInn= (n: string, msg?: any) => {
    if ((n?.length < 10 || n?.length > 10) || !n.match(/[0-9]/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateOGRN= (n: string, msg?: any) => {
    if ((n?.length < 13 || n?.length > 13) || !n.match(/[0-9]/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateOKVED= (n: string, msg?: any) => {
    if (n.match(/[A-Za-zА-Яа-я~!@#$%^&*()_+=-`{}\,]/)) {
        msg && msg()
        return true;
    }
    return false
}
import { EMAIL_REGEX } from "shared/utils/validate"

//todo Неочевидное поведение. Должно возвращать true, если проходит валидацию.
export const validateEmail = (n:string, msg?: any) => {
    if (!n.match(EMAIL_REGEX[0])) {
        msg && msg()
        return true;
    }
    return false
}

export const validatePhone= (n:string, msg?: any) => {
    if (!n.match(/[7-8\+]{1,2}\s[0-9]{3}\s[0-9]{3}-[0-9]{2}-[0-9]/)) {
        msg && msg()
        return true;
    }

    return false
}

export const validateLink = (n: string, msg?: any) => {
    if (!n.match(/^(ftp|http|https):\/\/[^ "]+$/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateWord= (n: string, msg?: any) => {
    if (n.match(/[0-9~!@#$%^&*()_+=-`{}\.\,]/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateInn= (n: string, msg?: any) => {
    if ((n?.length < 10 || n?.length > 10) || !n.match(/[0-9]/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateOGRN= (n: string, msg?: any) => {
    if ((n?.length < 13 || n?.length > 13) || !n.match(/[0-9]/)) {
        msg && msg()
        return true;
    }
    return false
}

export const validateOKVED= (n: string, msg?: any) => {
    if (n.match(/[A-Za-zА-Яа-я~!@#$%^&*()_+=-`{}\,]/)) {
        msg && msg()
        return true;
    }
    return false
}
